export default "__VITE_ASSET__E7m3F_A8__"